import { useEffect } from 'react'
import CustomHead from 'components/common/HeadMeta/HeadMeta'
import Template from 'components/downloads/DownloadFrameworkStrategy'

const Download: React.FC = () => {
  useEffect(() => {
    document.querySelector('body').classList.remove('non-chat')
  }, [])
  return (
    <>
      <CustomHead
        keyword={'AI駆動開発 AI RDRA DDD SDD フレームワーク'}
        image={'https://aitria.co.jp/images/img/download/framework-strategy/ogp.png'}
        url={'https://aitria.co.jp/download/framework-strategy/'}
        title="AI時代の開発フレームワーク戦略 | 資料ダウンロード | Aitria（アイトリア）"
        description="AI時代の開発フレームワーク戦略を経営者視点で解説。RDRA/DDD/SDDを組み合わせ、人材不足や開発コストを解決し、開発のスピード・品質・持続性を高める最新のAI駆動開発戦略をまとめました"
      />
      <Template />
    </>
  )
}

export default Download
